import React, { useState, useEffect } from 'react';
import CustomerFlasher from '../flasher/CustomerFlasher';

const UpdateView = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const [isChrome, setIsChrome] = useState(true); // Default to true to avoid flashing warning

  // Detect if the user is on a mobile device
  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileDevice = mobileRegex.test(userAgent);
      setIsMobile(isMobileDevice);
      setShowMobileWarning(isMobileDevice);
    };

    // Check if browser is Chrome
    const checkBrowser = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      const isChromeBrowser = /Chrome/.test(userAgent) && !/Edge/.test(userAgent) && !/Edg/.test(userAgent) && !/OPR/.test(userAgent);
      setIsChrome(isChromeBrowser);
    };

    checkIfMobile();
    checkBrowser();
  }, []);

  // Handle the dismissal of the mobile warning
  const dismissWarning = () => {
    setShowMobileWarning(false);
  };

  return (
    <>
      {/* Mobile Warning Modal */}
      {showMobileWarning && (
        <>
          <div className="modal-backdrop show"></div>
          <div 
            className="modal d-block" 
            tabIndex={-1} 
            role="dialog"
            aria-labelledby="mobileWarningLabel" 
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header bg-warning">
                  <h5 className="modal-title" id="mobileWarningLabel">Desktop Required</h5>
                  <button 
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={dismissWarning}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    To use the Web Flasher to update your Fluora device, please go to <b>https://firmware.fluoraplant.com/update</b> on a desktop computer and follow instructions.
                  </p>
                  <p className="mb-0">
                    <i>Mobile devices do not support the Web Serial API required for this process.</i>
                  </p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={dismissWarning}>
                    I understand
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      
      {isMobile && (
        <div className="alert alert-warning">
          <strong>Note:</strong> To use the Web Flasher to update your Fluora device, please go to <b>https://firmware.fluoraplant.com/update</b> on a desktop computer and follow instructions.
        </div>
      )}
      {!isMobile && (
        <>
          {!isChrome && (
            <div className="alert alert-danger mb-4">
              <strong>Browser Not Supported:</strong> This update process requires Google Chrome browser. Please <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">download and install Chrome</a> to continue.
            </div>
          )}
          {isChrome && <CustomerFlasher />}
        </>
      )}
    </>
  );
};

export default UpdateView;